/**
 * Logger utility that only logs in development mode
 * Use this instead of console.log for debug statements
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  log: (...args: any[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  
  debug: (...args: any[]) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },
  
  info: (...args: any[]) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
  
  warn: (...args: any[]) => {
    // Warnings should always show, but can be filtered in production if needed
    console.warn(...args);
  },
  
  error: (...args: any[]) => {
    // Errors should always show
    console.error(...args);
  },
};


